import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export default function ContactPage({ settings }) {
  return (
    <div data-testid="contact-page">
      <section className="hero-gradient py-16 sm:py-24">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <h1 className="text-4xl sm:text-5xl font-bold text-[#1d1d1f] tracking-tight">
            Get in touch
          </h1>
          <p className="mt-4 text-base text-[#86868b] max-w-md mx-auto">
            Questions about a MacBook? Need help with your purchase? We're here to help.
          </p>
        </div>
      </section>

      <section className="py-16 sm:py-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-6">
          <div className="space-y-8">
            {settings?.phone && (
              <div className="flex items-start gap-4" data-testid="contact-phone">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center shrink-0">
                  <Phone className="w-4 h-4 text-[#1d1d1f]" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-[#1d1d1f]">Phone</h3>
                  <a
                    href={`tel:${settings.phone}`}
                    className="text-sm text-[#86868b] hover:text-[#1d1d1f] transition-colors"
                  >
                    {settings.phone}
                  </a>
                </div>
              </div>
            )}

            {settings?.email && (
              <div className="flex items-start gap-4" data-testid="contact-email">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center shrink-0">
                  <Mail className="w-4 h-4 text-[#1d1d1f]" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-[#1d1d1f]">Email</h3>
                  <a
                    href={`mailto:${settings.email}`}
                    className="text-sm text-[#86868b] hover:text-[#1d1d1f] transition-colors"
                  >
                    {settings.email}
                  </a>
                </div>
              </div>
            )}

            {settings?.address && (
              <div className="flex items-start gap-4" data-testid="contact-address">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center shrink-0">
                  <MapPin className="w-4 h-4 text-[#1d1d1f]" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-[#1d1d1f]">Address</h3>
                  <p className="text-sm text-[#86868b]">{settings.address}</p>
                </div>
              </div>
            )}

            {settings?.hours && (
              <div className="flex items-start gap-4" data-testid="contact-hours">
                <div className="w-10 h-10 rounded-full bg-[#f5f5f7] flex items-center justify-center shrink-0">
                  <Clock className="w-4 h-4 text-[#1d1d1f]" />
                </div>
                <div>
                  <h3 className="text-sm font-semibold text-[#1d1d1f]">Business Hours</h3>
                  <p className="text-sm text-[#86868b]">{settings.hours}</p>
                </div>
              </div>
            )}

            {!settings?.phone && !settings?.email && !settings?.address && (
              <div className="text-center py-10" data-testid="contact-no-info">
                <p className="text-sm text-[#86868b]">
                  Contact information will appear here once configured in the admin dashboard.
                </p>
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}
